import React, { useState } from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';

const style = {
  position: 'absolute',
  width: '80%',
  maxWidth: '1000px',
  lineHeight: '24px',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  textAlign: 'left',
  bgcolor: 'background.paper',
  border: '1px solid #000',
  boxShadow: 24,
  p: 5,
};

const styleCloseIcon = {
  position: 'absolute',
  top: '10px',
  right: '10px',
  cursor: 'pointer',
};

export default function TransitionsModal({
  open,
  setOpen,
  queryFunction,
  roles,
  statuses,
  emailVerifieds,
  giveAways,
  templateName,
  userCount,
  loading,
}) {
  const handleClose = () => setOpen(false);
  const [disabled, setDisabled] = useState(true);

  const handleChange = (e) => {
    if (e.target.value === 'send email') {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  };

  const handleClick = () => {
    handleClose();
    queryFunction();
    setDisabled(true);
  };
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <Box sx={style}>
          <CloseRoundedIcon sx={styleCloseIcon} onClick={handleClose} color={'primary'} />
          <div className="userModalContainer">
            <h2>Confirm Email Details</h2>
            <h3>Selected User Filters:</h3>
            <div className="adminSendCustomEmailUserFiltersInModal">
              <div className="adminSendCustomEmailUserFiltersInModalFlex">
                <div className="left">
                  <div className="adminSendCustomEmailModalFilterItem">
                    <p>Roles: </p>
                    {roles.length ? (
                      roles.map((role) => (
                        <p className="adminSendCustomEmailModalFilterItemBox" key={role}>
                          {role}
                        </p>
                      ))
                    ) : (
                      <p>Not selected</p>
                    )}
                  </div>
                  <div className="adminSendCustomEmailModalFilterItem">
                    <p>Status: </p>

                    {statuses.length ? (
                      statuses.map((status) => (
                        <p className="adminSendCustomEmailModalFilterItemBox" key={status}>
                          {status}
                        </p>
                      ))
                    ) : (
                      <p>Not selected</p>
                    )}
                  </div>
                  <div className="adminSendCustomEmailModalFilterItem">
                    <p>Email Verified: </p>
                    {emailVerifieds.length ? (
                      emailVerifieds.map((emailVerified) => (
                        <p className="adminSendCustomEmailModalFilterItemBox" key={emailVerified}>
                          {emailVerified}
                        </p>
                      ))
                    ) : (
                      <p>Not selected</p>
                    )}
                  </div>
                  <div className="adminSendCustomEmailModalFilterItem">
                    <p>GiveAways: </p>
                    {giveAways.length ? (
                      giveAways.map((giveAway) => (
                        <p className="adminSendCustomEmailModalFilterItemBox" key={giveAway}>
                          {giveAway}
                        </p>
                      ))
                    ) : (
                      <p>Not selected</p>
                    )}
                  </div>
                </div>
                <div className="right">
                  {loading ? (
                    <CircularProgress />
                  ) : userCount ? (
                    <p>User Count: {userCount}</p>
                  ) : (
                    <p>No users matched with these filters!</p>
                  )}
                </div>
              </div>
            </div>
            <h3>Template</h3>
            <p>SendGrid template: {templateName || 'Not selected'}</p>
            <p>Type "send email" and click.</p>
            <TextField size="small" label="Confirm sending" variant="outlined" onChange={handleChange} />

            <Button
              className="pricingInfoModalButton"
              variant="contained"
              target={'blank'}
              onClick={handleClick}
              disabled={disabled || userCount === null || userCount === undefined}
            >
              SEND EMAIL
            </Button>
          </div>
        </Box>
      </Fade>
    </Modal>
  );
}
